/**
 * OmyBoat — Ports Render
 * Rendu HTML du dropdown et des cartes résultat
 * Dépend de : ports-utils.js (portsHighlight, portsEsc)
 */

(function () {
  'use strict';

  // ── Rendu dropdown principal ───────────────────────────────────────────────
  window.portsRenderDropdown = function (geo, cities, directPorts, q, radius) {
    var dropdown = document.getElementById('portsDropdown');
    if (!dropdown) return;
    var html = '';

    if (cities && cities.length) {
      var totalPorts = cities.reduce(function (s, c) { return s + (c.ports || []).length; }, 0);
      html += '<div class="dd-section-header">'
            + '⚓ Ports dans ' + radius + 'km'
            + '<div class="dd-section-count">' + totalPorts + ' ports · ' + cities.length + ' villes</div>'
            + '</div>';

      cities.forEach(function (city) {
        var distLabel = city.dist < 1 ? 'ici' : city.dist.toFixed(0) + ' km';
        html += '<div class="dd-city-row" onclick="portsSelectCity(\'' + city.slug + '\',\'' + window.portsEsc(city.ville) + '\')">'
              + '<div class="dd-city-icon">' + city.emoji + '</div>'
              + '<div class="dd-city-text">'
              + '<div class="dd-city-name">' + window.portsHighlight(city.ville, q) + '</div>'
              + '<div class="dd-city-sub">' + city.departement_nom + ' · ' + (city.ports || []).length + ' port(s)</div>'
              + '</div>'
              + '<div class="dd-city-right">'
              + '<div class="dd-city-dist">' + distLabel + '</div>'
              + '<div class="dd-city-tag">page ville →</div>'
              + '</div></div>';

        (city.ports || []).forEach(function (port) {
          html += '<div class="dd-port-row indented" onclick="portsSelectPort(\'' + port.slug + '\',\'' + city.slug + '\')">'
                + '<div class="dd-port-emoji">⚓</div>'
                + '<div class="dd-port-info">'
                + '<div class="dd-port-name">' + window.portsHighlight(port.nom, q) + '</div>'
                + '<div class="dd-port-sub">' + port.taille + ' · ' + port.anneaux + ' anneaux</div>'
                + '</div></div>';
        });
      });
    }

    if (directPorts && directPorts.length) {
      html += '<div class="dd-section-header">⚓ Ports correspondants <div class="dd-section-count">' + directPorts.length + '</div></div>';
      directPorts.forEach(function (port) {
        html += '<div class="dd-port-row" onclick="portsSelectPort(\'' + port.slug + '\',\'' + port.citySlug + '\')">'
              + '<div class="dd-port-emoji">' + port.emoji + '</div>'
              + '<div class="dd-port-info">'
              + '<div class="dd-port-name">' + window.portsHighlight(port.nom, q) + '</div>'
              + '<div class="dd-port-sub">' + port.ville + ' · ' + port.dept + ' · ' + port.taille + '</div>'
              + '</div>'
              + '<div class="dd-port-right"><div class="dd-boat-badge">' + port.anneaux + ' anneaux</div></div>'
              + '</div>';
      });
    }

    if (!html) { window.portsRenderEmpty(q); return; }
    dropdown.innerHTML = html;
    dropdown.classList.add('visible');
  };

  window.portsRenderEmpty = function (q) {
    var dropdown = document.getElementById('portsDropdown');
    if (!dropdown) return;
    dropdown.innerHTML = '<div class="dd-empty"><span class="dd-empty-icon">📍'
      + '</span>Aucun resultat pour "<strong>' + q + '</strong>"<br><small>Essayez : Toulon, Cannes...</small></div>';
    dropdown.classList.add('visible');
  };
  window.portsHideDropdown = function () {
    var dropdown = document.getElementById('portsDropdown');
    if (!dropdown) return;
    dropdown.classList.remove('visible');
    dropdown.innerHTML = '';
  };
  window.portsRenderCityCard = function (city) {
    var card = document.getElementById('portsSelectedCard');
    if (!card) return;
    var portsHTML = (city.ports || []).map(function (p) {
      return '<div class="spc-port-row" onclick="portsSelectPort(\'' + p.slug + '\',\'' + city.slug + '\')">'
           + '<div class="spc-port-name">⚓ ' + p.nom + '</div>'
           + '<div class="spc-port-sub">' + p.taille + ' · ' + p.anneaux + ' anneaux'
           + (p.note ? ' · ' + p.note : '') + '</div>'
           + '</div>';
    }).join('');
    card.innerHTML = '<div class="spc-header"><div class="spc-check">' + city.emoji + '</div><div><div class="spc-title">' + city.ville + '</div><div class="spc-sub">' + city.departement_nom + ' · ' + (city.ports || []).length + ' port(s)</div></div></div><div class="spc-body"><div style="font-size:0.78rem;color:#6B7280;margin-bottom:8px;font-weight:600;text-transform:uppercase;letter-spacing:0.5px">Choisir un port :</div>' + portsHTML + '<button class="spc-change" onclick="portsReset()">ↀ Autre ville ou port</button></div>';
    card.classList.add('visible');
  };
  window.portsRenderPortCard = function (port, city) {
    var card = document.getElementById('portsSelectedCard');
    if (!card) return;
    var filterUrl = '/collections/all?filter.p.m.omyboat.port_attache_slug=' + port.slug;
    card.innerHTML = '<div class="spc-header"><div class="spc-check">✓</div><div><div class="spc-title">Port de départ sélectionné</div><div class="spc-sub">' + city.emoji + ' ' + port.nom + ' · ' + city.ville + '</div></div></div><div class="spc-body"><div class="spc-info-grid"><div class="spc-info-item"><div class="spc-info-label">Ville</div><div class="spc-info-value">' + city.ville + '</div></div><div class="spc-info-item"><div class="spc-info-label">Département</div><div class="spc-info-value">' + city.departement_nom + '</div></div><div class="spc-info-item"><div class="spc-info-label">Anneaux</div><div class="spc-info-value">' + port.anneaux + '</div></div><div class="spc-info-item"><div class="spc-info-label">Taille</div><div class="spc-info-value">' + port.taille + '</div></div></div>' + (port.note ? '<p style="font-size:0.78rem;color:#4b5563;line-height:1.5;margin-bottom:14px">' + port.note + '</p>' : '') + '<a href="' + filterUrl + '" class="spc-cta">🚔 Voir les bateaux disponibles →</a><button class="spc-change" onclick="portsReset()">← Changer de port</button></div>';
    card.classList.add('visible');
  };

})();
